import { render, staticRenderFns } from "../spotForm/spotForm.html?vue&type=template&id=3b6b3785&scoped=true&external"
import script from "../spotForm/spotForm.js?vue&type=script&lang=js&external"
export * from "../spotForm/spotForm.js?vue&type=script&lang=js&external"
import style0 from "../spotForm/spotForm.css?vue&type=style&index=0&id=3b6b3785&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6b3785",
  null
  
)

export default component.exports